import type { WeddingData } from "../types/wedding";

export const blankWeddingData: WeddingData = {
  project: {
    id: "blank-wedding-project",
    name: "New Wedding Invitation",
    slug: "new-wedding",
    status: "draft",
    language: "id",
    timezone: "Asia/Jakarta",
    createdAt: "2026-01-01T00:00:00.000Z",
    updatedAt: "2026-01-01T00:00:00.000Z",
    publishedAt: null
  },
  invitation: {
    guestName: "Tamu & pasangan",
    title: "Nama Pasangan",
    subtitle: "Wedding Invitation",
    openingText: "Kami mengundang Anda untuk merayakan hari bahagia bersama kami.",
    closingText: "Kehadiran Anda akan melengkapi kebahagiaan kami.",
    coverImage: "/placeholders/cover-placeholder.svg",
    coverVideo: "",
    openButtonText: "Buka Undangan"
  },
  couple: {
    groom: {
      fullName: "Nama Pengantin Pria",
      displayName: "Pengantin Pria",
      parents: "",
      instagram: "",
      photo: "/placeholders/person-placeholder.svg"
    },
    bride: {
      fullName: "Nama Pengantin Wanita",
      displayName: "Pengantin Wanita",
      parents: "",
      instagram: "",
      photo: "/placeholders/person-placeholder.svg"
    }
  },
  story: {
    enabled: true,
    title: "Our Story",
    introduction: "Tambahkan cerita perjalanan cinta Anda.",
    items: [
      {
        id: "story-placeholder",
        date: "Tahun",
        title: "Judul Cerita",
        description: "Tambahkan cerita singkat tentang momen penting Anda.",
        image: "",
        order: 0
      }
    ]
  },
  events: [
    {
      id: "event-placeholder",
      type: "reception",
      title: "Acara Pernikahan",
      date: "",
      startTime: "",
      endTime: "",
      timezone: "Asia/Jakarta",
      venueName: "Tambahkan lokasi",
      address: "Tambahkan alamat",
      mapsUrl: "",
      additionalInformation: "",
      order: 0
    }
  ],
  countdown: {
    enabled: false,
    eventId: "event-placeholder",
    targetDate: ""
  },
  gallery: {
    enabled: true,
    title: "Gallery",
    images: []
  },
  music: {
    enabled: false,
    url: "",
    title: "",
    artist: "",
    autoplayAfterInteraction: true,
    loop: true,
    volume: 0.5
  },
  rsvp: {
    enabled: true,
    title: "RSVP",
    description: "Mohon konfirmasi kehadiran Anda.",
    deadline: "",
    maximumGuests: 2,
    attendanceOptions: ["Hadir", "Tidak hadir"]
  },
  gifts: {
    enabled: false,
    title: "Wedding Gift",
    description: "Tambahkan informasi hadiah jika diperlukan.",
    backgroundImage: "/placeholders/section-placeholder.svg",
    bankAccounts: [],
    qrCodes: []
  },
  liveStreaming: {
    enabled: false,
    title: "Live Streaming",
    description: "",
    url: "",
    thumbnail: "",
    startDate: ""
  },
  wishes: {
    enabled: true,
    title: "Wishes for Us",
    description: "Tinggalkan doa dan pesan hangat.",
    emojiOptions: ["❤️", "✨", "🙏", "💍"],
    moderationEnabled: true
  },
  barcode: {
    enabled: false,
    title: "Invitation Barcode",
    description: "Tunjukkan barcode ini saat resepsi.",
    image: ""
  },
  closing: {
    image: "/placeholders/cover-placeholder.svg",
    title: "",
    message: "Kehadiran Anda akan membuat hari bahagia kami semakin lengkap.",
    signature: "Nama Pasangan"
  },
  navigation: {
    enabled: true,
    items: [
      { id: "nav-events", label: "Detail", target: "events", order: 0 },
      { id: "nav-story", label: "Story", target: "story", order: 1 },
      { id: "nav-gallery", label: "Gallery", target: "gallery", order: 2 },
      { id: "nav-rsvp", label: "RSVP", target: "rsvp", order: 3 }
    ]
  },
  theme: {
    primaryColor: "#314334",
    secondaryColor: "#7a8b72",
    accentColor: "#b68566",
    backgroundColor: "#f7f3eb",
    textColor: "#1c1b19",
    headingFont: "Georgia, 'Times New Roman', serif",
    bodyFont: "Inter, ui-sans-serif, system-ui, sans-serif",
    sectionSpacing: "clamp(72px, 10vw, 140px)",
    animationStyle: "warm"
  },
  layout: { elements: {} },
  sections: [
    ["cover", true], ["couple", true], ["story", true], ["countdown", false],
    ["events", true], ["rsvp", true], ["gallery", true], ["gift", false],
    ["liveStreaming", false], ["wishes", true], ["closing", true]
  ].map(([type, enabled], order) => ({
    id: `section-${type}`,
    type: type as WeddingData["sections"][number]["type"],
    enabled: enabled as boolean,
    order,
    settings: type === "cover"
      ? { heroImage: "/placeholders/cover-placeholder.svg", mobileHeroImage: "/placeholders/cover-placeholder.svg" }
      : type === "couple"
        ? { introBackground: "/placeholders/section-placeholder.svg" }
        : type === "events"
          ? { photoBreak: "/placeholders/section-placeholder.svg" }
          : {}
  })),
  seo: {
    title: "Wedding Invitation",
    description: "Digital wedding invitation.",
    ogImage: "/placeholders/cover-placeholder.svg",
    favicon: "",
    noIndex: true
  }
};
